<template>
  <div class="chat_header d-flex py-2 px-2 px-md-5" :class="{ pointer: !chatItem.isPlug }">
    <v-hover v-if="$vuetify.breakpoint.smAndDown" v-slot="{ hover }">
      <router-link
        tag="button"
        :to="{ name: 'chat' }"
        class="d-flex align-center px-1 h-100 mr-2"
        :class="{ 'dropdown-btn--active': $refs.Menu && $refs.Menu.isActive }"
      >
        <v-icon large :color="hover ? 'primary' : 'secondary'"> mdi-arrow-left </v-icon>
      </router-link>
    </v-hover>
    <ChatInfo
      v-if="chatItem"
      @click="clickHeader"
      :params="chatItem"
      :chatTranslations="chatTranslations"
      :avatarSize="$vuetify.breakpoint.smAndDown ? 50 : 75"
    />
    <v-menu
      v-if="chatItem.actionEnabled && !chatItem.isPlug"
      ref="Menu"
      content-class="dropdown-content white rounded"
      offset-y
      close-on-content-click
    >
      <template v-slot:activator="{ on, attrs }">
        <button
          v-bind="attrs"
          v-on="on"
          class="dropdown-btn d-flex align-center px-5 h-100"
          :class="{ 'dropdown-btn--active': $refs.Menu && $refs.Menu.isActive }"
        >
          <MenuMoreIcon />
        </button>
      </template>
      <template v-for="(item, index) in buttons">
        <ChatContextMenuItem :item="item" :key="index" />
      </template>
    </v-menu>
    <!-- <div class="dropdown"></div> -->
    <div class="select_btns white py-2 px-2 px-md-5" v-if="chatSelectedMessages.length > 0">
      <div class="select_btns__main">
        <BaseButton
          default_icon="chat-share"
          :text="
            localStorage.translations.pages.common.buttons.share +
            ' ' +
            '(' +
            chatSelectedMessages.length +
            ')'
          "
          @click="clickShareButton"
        />
        <BaseButton
          v-if="chatSelectedMessagesAllFromCurrentUser"
          :text="
            localStorage.translations.pages.common.buttons.udalit +
            ' ' +
            '(' +
            chatSelectedMessages.length +
            ')'
          "
          default_icon="chat-trash"
          @click="DELETE_chatSelectedMessages"
        />
      </div>
      <BaseButton
        default_icon="button-back"
        :text="localStorage.translations.pages.common.buttons.otmenit"
        @click="CLEAR_chatSelectedMessages"
      />
    </div>
  </div>
</template>

<script>
import MenuMoreIcon from 'components/icons/MenuMore'
import ChatInfo from 'components/chat/ChatInfo'
import ChatContextMenuItem from 'components/chat/contextMenu/ChatContextMenuItem'
import { mapActions, mapGetters, mapState } from 'vuex'
import chat_context from '~/configs/chat/contextMenu'
export default {
  name: 'ChatHeader',
  components: { ChatInfo, MenuMoreIcon, ChatContextMenuItem },
  props: {
    chatItem: Object,
    chatTranslations: Object,
    onChatModalOpen: Function,
  },
  computed: {
    ...mapState('chat/messages', ['chatSelectedMessages']),
    ...mapGetters('chat/messages', ['chatSelectedMessagesAllFromCurrentUser']),
    buttons() {
      return this.chatItem
        ? chat_context({
            chatItem: this.chatItem,
          })
        : []
    },
  },
  methods: {
    ...mapActions('chat', [
      'CHANGE_chatNotification',
    ]),
    ...mapActions('chat/messages', [
      'DELETE_chatMessagesClear',
      'CLEAR_chatSelectedMessages',
      'DELETE_chatSelectedMessages',
    ]),
    clickHeader() {
      if (!this.chatItem.isPlug) {
        let data = {
          action: 'info',
          type: this.chatItem.type,
        }
        this.$emit('click', data)
      }
    },
    clickShareButton() {
      this.onChatModalOpen({
        type: 'SHARE',
        messagesId: this.chatSelectedMessages.map((i) => i.id),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_header {
  position: relative;
  .select_btns {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: grid;
    grid-template-columns: max-content auto;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    &__main {
      display: flex;
      gap: inherit;
    }
  }
}
.dropdown-btn {
  transition: 0.3s;
  svg:deep() {
    circle {
      fill: var(--v-secondary-darken2);
    }
  }
  &:hover {
    svg:deep() {
      circle {
        fill: var(--v-primary-base);
      }
    }
  }
  &--active {
    background: #277faf27;
    border-radius: 10px;
  }
}
</style>
